import { Injectable } from "@angular/core";
import {
  BroadcastChannelMessageType,
  BroadcastChannelPayload,
} from "@src/app/shared/models";
import { filter, Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BroadcastChannelService {
  private broadcastChannel: BroadcastChannel;
  private onMessage = new Subject<BroadcastChannelPayload>();

  private BROADCAST_CHANNEL_NAME = 'broadcast-channel';

  constructor() {
    this.broadcastChannel = new BroadcastChannel(this.BROADCAST_CHANNEL_NAME);
    this.broadcastChannel.onmessage = (event: MessageEvent) => {
      this.onMessage.next(event.data as BroadcastChannelPayload);
    }
  }

  /**
   * Publishes a message to the broadcast channel.
   * @param message - The message to publish.
   */
  publish(message: BroadcastChannelPayload): void {
    this.broadcastChannel.postMessage(message);
  }

  /**
   * Subscribes to a message from the broadcast channel.
   * @param type - The type of message to subscribe to.
   * @returns An observable of the message.
   */
  subscribeToMessage<T extends BroadcastChannelMessageType>(
    type: T
  ): Observable<Extract<BroadcastChannelPayload, { type: T }>> {
    return this.onMessage.pipe(
      filter((message): message is Extract<BroadcastChannelPayload, { type: T }> =>
        message.type === type
      ),
    );
  }
}